module.exports = __webpack_public_path__ + "media/assets/img/flags/en-US-f6045bf922706ed74bea0cdaef9853c0.png";